import { Store } from '../../../flux/Store';
import { assertArray, assertTrue } from "../assert";
import { Timezone } from "../../../rest/Misc";
import { names } from "./TimezoneActions";

export interface TimezoneStoreState
{
    timezones: Timezone[];
}

// TimezoneStore is a central storage for loaded Timezones
export class TimezoneStore extends Store<TimezoneStoreState>
{
    constructor()
    {
        super();
        this.state = this.field({ timezones: [] });

        this.register<Timezone[]>(names.SET_TIMEZONES, e => {
            const timezones = e.payload;
            assertArray(timezones, 'expected array payload');
            return this.field({ timezones });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/TimeZone/TimeZoneStore.ts